/**
 * Where a project opens for this person. Decided by permissions, never by a
 * role name: people who operate the site (diary, progress, task updates)
 * start on Site › Today; everyone else (owner side, viewers) on the Overview.
 */
import type { Me } from '@/lib/api/types';

import { PERMISSIONS as P, projectPermissions } from './permissions';

export type ProjectLanding = '/projects/$projectId/site/today' | '/projects/$projectId/overview';

export function projectLanding(me: Me | null, projectId: string): ProjectLanding {
  const granted = projectPermissions(me, projectId);
  const operatesSite =
    granted.has(P.siteView) &&
    [P.diaryWrite, P.progressWrite, P.tasksUpdate].some((permission) => granted.has(permission));
  return operatesSite ? '/projects/$projectId/site/today' : '/projects/$projectId/overview';
}
